import React, { Component } from 'react';
import ContentOutline from '../ContentOutline';
import TextBlock from '../TextBlock';
import LeftRightTable from '../LeftRightTable';

import sharedStyles from '../sharedStyles.scss';

const TEST_SPECIFICATIONS = {
  subtitle: 'Step 1 test specifications',
  leftColumnTitle: 'System',
  rightColumnTitle: '% range',
  records: [
    {
      left: 'General Principles [^1]',
      right: '13-17',
    },
    {
      left: 'Blood & Lymphoreticular/Immune Systems',
      right: '7-11',
    },
    {
      left: 'Behavioral Health & Nervous Systems/Special Senses',
      right: '9-13',
    },
    {
      left: 'Musculoskeletal, Skin & Subcutaneous Tissue',
      right: '6-10',
    },
    {
      left: 'Cardiovascular System',
      right: '6-10',
    },
    {
      left: 'Respiratory & Renal/Urinary Systems',
      right: '9-13',
    },
    {
      left: 'Gastrointestinal System',
      right: '5-9',
    },
    {
      left: 'Reproductive & Endocrine Systems',
      right: '9-13',
    },
    {
      left: 'Multisystem Processes & Disorders',
      right: '7-11',
    },
    {
      left: 'Biostatistics & Epidemiology/Population Health',
      right: '5-7',
    },
    {
      left: 'Social Sciences: Communication Skills/Ethics',
      right: '3-5',
    },
  ],
};

const PROCESS_SPECIFICATIONS = {
  subtitle: 'Step 1 process specifications',
  leftColumnTitle: 'Processes',
  rightColumnTitle: '% range',
  records: [
    {
      left: 'Normal Processes [^1]',
      right: '10-15',
    },
    {
      left: 'Abnormal Processes',
      right: '55-60',
    },
    {
      left: 'Principles of Therapeutics',
      right: '15-20',
    },
    {
      left: 'Other [^2]',
      right: '10-15',
    },
  ],
};

const COMPETENCY_SPECIFICATIONS = {
  subtitle: 'Step 1 physician tasks / competencies specifications',
  leftColumnTitle: 'Competency',
  rightColumnTitle: '% range',
  records: [
    {
      left: 'Medical Knowledge: Applying Foundational Science Concepts',
      right: '52-62',
    },
    {
      left: (
        <div>
          <p>Patient Care: Diagnosis</p>
          <ul>
            <li>History / Physical Examination</li>
            <li>Laboratory / Diagnostic Studies</li>
            <li>Diagnosis</li>
          </ul>
        </div>
      ),
      right: '20-30',
    },
    {
      left: (
        <div>
          <p>Patient Care: Management</p>
          <ul>
            <li>Health Maintenance / Disease Prevention</li>
            <li>Pharmacotherapy</li>
          </ul>
        </div>
      ),
      right: '7-12',
    },
    {
      left: 'Communication/Professionalism',
      right: '2-5',
    },
    {
      left: 'Practice-based Learning & Improvement',
      right: '5-7',
    },
  ],
};

const DISCIPLINE_SPECIFICATIONS = {
  subtitle: 'Step 1 discipline specifications',
  leftColumnTitle: 'System',
  rightColumnTitle: '% range',
  records: [
    {
      left: 'Pathology',
      right: '45-52',
    },
    {
      left: 'Physiology',
      right: '26-34',
    },
    {
      left: 'Pharmacology',
      right: '16-23',
    },
    {
      left: 'Biochemistry & Nutrition',
      right: '14-24',
    },
    {
      left: 'Microbiology & Immunology',
      right: '15-22',
    },
    {
      left: 'Gross Anatomy & Embryology',
      right: '11-15',
    },
    {
      left: 'Histology & Cell Biology',
      right: '9-13',
    },
    {
      left: 'Behavioral Sciences',
      right: '8-13',
    },
    {
      left: 'Genetics',
      right: '5-9',
    },
  ],
};

class UsmleStep1 extends Component {
  render() {
    const { currentUser, product, inflatedContent } = this.props;

    return (
      <div className={sharedStyles.layout}>
        <div className={sharedStyles.title}>
          United States Medical Licensing Exam{' '}
          <span className={sharedStyles.shortTitle}>(USMLE)</span> Step 1
        </div>
        <div className={sharedStyles.explanation}>
          <div className={sharedStyles.blurb}>
            The USMLE Step 1 is a comprehensive overview of the medical field, and is the
            first required exam for a National Board of Medical Examiners (NBME) license.
          </div>
          <div className={sharedStyles.facts}>
            <ul>
              <li>
                <em>Time</em>8 hours (7x60min)
              </li>
              <li>
                <em>Format</em> approx. 280 questions
              </li>
              <li>
                <em>Exam fee</em> $645
              </li>
              <li>
                <em>Details</em>{' '}
                <a
                  href="https://www.usmle.org/step-1/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  USMLE <i className="fad fa-external-link" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <TextBlock title="NBME’s exam summary">
          <LeftRightTable {...TEST_SPECIFICATIONS} />
          <br />
          <p className={sharedStyles.small}>
            [^1] The General Principles category for the Step 1 examination includes test
            items concerning those normal and abnormal processes that are not limited to
            specific organ systems. Categories for individual organ systems include test
            items concerning those normal and abnormal processes that are system-specific.
          </p>
          <LeftRightTable {...PROCESS_SPECIFICATIONS} />
          <br />
          <p className={sharedStyles.small}>
            [^1] This category includes questions about normal structure and function that
            may appear in the context of an abnormal clinical presentation.
          </p>
          <p className={sharedStyles.small}>
            [^2] Approximately 10% to 15% of questions are not classified in the normal
            processes, abnormal processes, or principles of therapeutics categories. These
            questions are likely to be classified in the general principles,
            biostatistics/evidence-based medicine, or social sciences categories in the
            USMLE Content Outline.
          </p>
          <LeftRightTable {...COMPETENCY_SPECIFICATIONS} />

          <LeftRightTable {...DISCIPLINE_SPECIFICATIONS} />
        </TextBlock>

        <ContentOutline
          currentUser={currentUser}
          product={product}
          inflatedContent={inflatedContent}
        />
      </div>
    );
  }
}

export default UsmleStep1;
